/*
 * @Author: Ryan
 * @Date: 2026-01-21
 * @Description: 快捷入口卡片组件 - 点击切换下拉选项
 */
import Image from 'next/image';
import { FC } from 'react';

import { generatorOptions } from './config';
import styles from './index.module.scss';

// 默认图片数据，与 generatorOptions 的 key 一一对应
const defaultCardImages: Record<string, { imageUrl: string; alt: string }> = {
  'ugc-video-ads': {
    imageUrl: 'https://assets.falcocut.ai/ai-ugc-video-generator/ugc-video-ads.png',
    alt: 'UGC Video Ads',
  },
  'video-from-product-image': {
    imageUrl:
      'https://assets.falcocut.ai/ai-ugc-video-generator/video-from-product-image.png',
    alt: 'Video from Product Image',
  },
  'video-from-avatar-image': {
    imageUrl:
      'https://assets.falcocut.ai/ai-ugc-video-generator/video-from-avatar-image.png',
    alt: 'Video from Avatar Image',
  },
  'generate-image': {
    imageUrl: 'https://assets.falcocut.ai/ai-ugc-video-generator/generate-image.png',
    alt: 'Generate Image',
  },
};

export interface QuickCardsProps {
  onSelectType: (type: string) => void;
  /** 自定义卡片图片，传入时自动显示图片下方文字标签 */
  cardImages?: Record<string, { imageUrl: string; alt: string }>;
}

const QuickCards: FC<QuickCardsProps> = ({ onSelectType, cardImages }) => {
  const images = cardImages || defaultCardImages;

  return (
    <div className={styles.quickCards}>
      {generatorOptions.map((option) => {
        const imageData = images[option.key];
        if (!imageData) return null;

        return (
          <button
            key={option.key}
            type="button"
            className={`${styles.quickCard} ${styles.quickCardWithLabel}`}
            onClick={() => onSelectType(option.key)}
          >
            <div className={styles.quickCardImageWrapper}>
              <Image
                src={imageData.imageUrl}
                alt={imageData.alt}
                fill
                className={styles.quickCardImage}
                sizes="(max-width: 768px) 100vw, 176px"
              />
            </div>
            <span className={styles.quickCardLabel}>{option.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default QuickCards;
